import axiosApi from "shared/api/axiosApi";
import { checkCurrentLanguage } from "shared/lib/checkCurrentLanguage";
import { GetProductCategoriesParams, GetProductCategoriesResponse, CreateProductCategoryBody } from "./types";

export const productCategoriesApi = {
  getProductsCategories: async (params: GetProductCategoriesParams): Promise<GetProductCategoriesResponse[]> => {
    const response = await axiosApi.get<GetProductCategoriesResponse[]>(
      `/productCategories`,
      {
        params: params,
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  getProductsCategoriesForInfinitySelect: async (params: GetProductCategoriesParams): Promise<GetProductCategoriesResponse[]> => {
    const response = await axiosApi.get<GetProductCategoriesResponse[]>(
      `/productCategories`,
      {
        params: params,
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  getProductCategoryByCategoryId: async (categoryId: number): Promise<GetProductCategoriesResponse> => {
    const response = await axiosApi.get<GetProductCategoriesResponse>(
      `/productCategories/${categoryId}`,
      {
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  createProductCategory: async (
    data: CreateProductCategoryBody
  ): Promise<number> => {
    const response = await axiosApi.post<number>(
      `/productCategories`,
      data,
      {
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  updateProductCategory: async (
    data: CreateProductCategoryBody
  ): Promise<number> => {
    const response = await axiosApi.put<number>(
      `/productCategories`,
      data,
      {
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  deleteProductCategoryByCategoryId: async (categoryId: number): Promise<void> => {
    const response = await axiosApi.delete<void>(
      `/productCategories/${categoryId}`,
      {
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
}